module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', _vm._b({
    ref: "form",
    attrs: {
      "label-position": _vm.labelPosition
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, 'el-form', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c989298"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtForm.vue
// module id = 1535
// module chunks = 124